const DEFAULT_GC_CONFIG = {
  enabled: false,
  logo: 'https://images-static.nykaa.com/uploads/cbe6c711-f6cf-4b09-946e-671569d790e3.jpg',
  title: 'Redirect to Complete Purchase',
  desc: 'Buy Gift Cards on our sister app (Nykaa.com) & use it to shop on Nykaa Fashion, Nykaa Man & Nykaa.com!',
  confirmText: 'Buy gift card',
  cancelText: 'Back to Home',
  utmCampaign: 'gc_purchase',
  giftCardUrl:
    'https://www.nykaa.com/giftcard/list?utm_souce=nykaafashion&utm_medium=referral&utm_campaign=gc_purchase',
  myAccountGiftcardTitle: 'Gift Card',
};

export const getGiftCardRemoteConfig = (
  config: typeof DEFAULT_GC_CONFIG
): typeof DEFAULT_GC_CONFIG => {
  return {
    ...DEFAULT_GC_CONFIG,
    ...(config || {}),
  };
};
